export default {"src":"/_next/static/media/distributor.fda615fa.svg","height":36,"width":25};